import React from "react";
import classnames from "classnames";
import styles from "./ToolBarNav.module.scss";

interface ToolBarNavProps {
  children: JSX.Element | JSX.Element[];
  className?: string;
}

export const toolbarNavUnderlineLinkClass = styles.underlineLink;
export const toolbarNavBoldLinkClass = styles.boldLink;

const ToolBarNav = ({ children, className }: ToolBarNavProps) => {
  return <div className={classnames(styles.root, className)}>{children}</div>;
};
export default ToolBarNav;
